// extracted by mini-css-extract-plugin
export default {"mainContainer":"giftStore_mainContainer__hZt0N","header":"giftStore_header__dyIOG","scrollableContainer":"giftStore_scrollableContainer__SuWbt"};